import { render, staticRenderFns } from "./FailedUsersRooms.vue?vue&type=template&id=812b1a70&"
import script from "./FailedUsersRooms.vue?vue&type=script&lang=js&"
export * from "./FailedUsersRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports